import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DocumentTemplateForm, DocumentTemplateFormValues } from "./DocumentTemplateForm";
import { documentTemplatesApi } from "api";
import { routes } from "consts";
import { useToaster } from "utils";
import { useDocumentTemplate } from "api/hooks";
import { PaziaLoader } from "components/atoms";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";

export const EditDocumentPage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const { documentTemplateId } = useParams();
  const { data, loading } = useDocumentTemplate(Number(documentTemplateId));

  const onSubmit = async (data: DocumentTemplateFormValues) => {
    try {
      await documentTemplatesApi.update(Number(documentTemplateId), data);
      navigate(routes.DOCUMENTS);
      showSuccess(`Zaktualizowano dokument`);
    } catch (error) {
      console.error(error);
      showError(`Wystąpił błąd podczas aktualizacji dokumentu`);
    }
  };

  if (loading) return <PaziaLoader position="center" />;
  if (!data) return null;

  const breadcrumbs = [{ title: "Szablony dokumentów", path: routes.DOCUMENTS }, { title: data.name }];

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edytuj szablon" />
      <DocumentTemplateForm onSubmit={onSubmit} template={data} />
    </PageMain>
  );
};
